"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("../../utils/api");
var redux_1 = require("redux");
var constants_1 = require("./constants");
var reducers = {
    isFocused: api_1.createCustomModuleReducer((_a = {},
        _a[constants_1.SET_IS_FOCUSED] = function (state, action) { return action.payload; },
        _a[constants_1.SET_FOCUSED_STATE] = function (state, action) { return action.payload.isFocused; },
        _a), false),
    focusedRow: api_1.createCustomModuleReducer((_b = {},
        _b[constants_1.SET_FOCUSED_ROW] = function (state, action) { return action.payload; },
        _b[constants_1.SET_FOCUSED_STATE] = function (state, action) { return action.payload.rowIndex; },
        _b), 0),
    focusedElement: api_1.createCustomModuleReducer((_c = {},
        _c[constants_1.SET_FOCUSED_ELEMENT] = function (state, action) { return action.payload; },
        _c[constants_1.SET_FOCUSED_STATE] = function (state, action) { return action.payload.elementIndex; },
        _c), 0),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map